export const yearsOfExperience = (year: number) => new Date().getFullYear() - year;
